import { render, staticRenderFns } from "./ConfirmLock.vue?vue&type=template&id=1ece9d6c&scoped=true&"
import script from "./ConfirmLock.vue?vue&type=script&lang=js&"
export * from "./ConfirmLock.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmLock.vue?vue&type=style&index=0&id=1ece9d6c&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ece9d6c",
  null
  
)

export default component.exports